import i18n from '@/shared/i18n';
import BaseModel from '@/core/components/input-widget/BaseModel';

export default class TransferAcrossBranchesModel extends BaseModel {
  branch_uuid = null;
  receipt_uuid = null;
  item_location_uuid = null;
  note = '';

  attributeLabels = {
    branch_uuid: i18n.t('Branch'),
    receipt_uuid: i18n.t('Receipt'),
    item_location_uuid: i18n.t('Item Location'),
    note: i18n.t('Note'),
  };

  rules = {
    branch_uuid: 'required',
    item_location_uuid: 'required',
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();
    if (data.receipt_uuid === '') {
      data.receipt_uuid = null;
    }
    return data;
  }
}
